import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const adminAxios = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

adminAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

adminAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUsername');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export const adminApi = {
  login: (username: string, password: string) => 
    adminAxios.post('/api/admin/login', { username, password }),
  
  getStats: () => 
    adminAxios.get('/api/admin/stats'),
  
  getUsers: (limit = 100, offset = 0) => 
    adminAxios.get('/api/admin/users', { params: { limit, offset } }),
  
  getUserById: (userId: string) => 
    adminAxios.get(`/api/admin/users/${userId}`),
  
  updateUser: (userId: string, data: any) => 
    adminAxios.put(`/api/admin/users/${userId}`, data),
  
  deleteUser: (userId: string) => 
    adminAxios.delete(`/api/admin/users/${userId}`),
  
  disableUser: (userId: string) => 
    adminAxios.post(`/api/admin/users/${userId}/disable`),
  
  enableUser: (userId: string) =>
    adminAxios.post(`/api/admin/users/${userId}/enable`),

  setGracePeriod: (userId: string, enabled: boolean) =>
    adminAxios.post(`/api/admin/users/${userId}/grace-period`, { enabled }),

  getTemplates: (limit = 100, offset = 0) =>
    adminAxios.get('/api/admin/templates', { params: { limit, offset } }),

  getTemplateById: (templateId: string) =>
    adminAxios.get(`/api/admin/templates/${templateId}`),

  createTemplate: (data: any) =>
    adminAxios.post('/api/admin/templates', data),

  updateTemplate: (templateId: string, data: any) =>
    adminAxios.put(`/api/admin/templates/${templateId}`, data),

  deleteTemplate: (templateId: string) =>
    adminAxios.delete(`/api/admin/templates/${templateId}`),

  // Source management
  getSources: (limit = 100, offset = 0) =>
    adminAxios.get('/api/admin/sources', { params: { limit, offset } }),

  getSourceById: (sourceId: string) =>
    adminAxios.get(`/api/admin/sources/${sourceId}`),

  createSource: (data: { name: string; url?: string; templateIds?: string[]; availableForAll?: boolean }) =>
    adminAxios.post('/api/admin/sources', data),

  updateSource: (sourceId: string, data: { name?: string; url?: string; templateIds?: string[]; availableForAll?: boolean }) =>
    adminAxios.put(`/api/admin/sources/${sourceId}`, data),

  deleteSource: (sourceId: string) =>
    adminAxios.delete(`/api/admin/sources/${sourceId}`),
};

export default adminAxios;